import { useEffect, useState } from "react";
import {
	Create,
	FileField,
	FileInput,
	RadioButtonGroupInput,
	SimpleForm,
	TextInput,
	useGetList,
	useNotify,
	useRedirect,
	useRefresh,
	useTranslate,
} from "react-admin";

import { transformToFormData } from "../../utils/customFunctions";
import { validateBackgroundModuleData } from "./backgroundModuleValidate";
import { CustomToolbar } from "../../customComponents/CustomToolbar";

const getChoices = (items) => Object.values(items).map((item) => item);

const transform = ({ ...data }) => {
	let mutatedData = {};

	Object.entries(data).forEach(([key, value]) => {
		const [keyPrefix, keyLanguageId] = key.split("_");

		if (keyPrefix !== "language") mutatedData[key] = value;

		if (keyPrefix === "language" && keyLanguageId === data.languageId)
			Object.entries(value).forEach(([fileName, file]) => {
				if (file) mutatedData[fileName] = value[fileName];
			});
	});

	return transformToFormData(mutatedData);
};

export const BackgroundModuleCreate = (props) => {
	const [languageData, setLanguageData] = useState([]);
	const translate = useTranslate();
	const redirect = useRedirect();
	const refresh = useRefresh();
	const notify = useNotify();

	const { data: languageDataObj } = useGetList(
		"languages",
		{ page: 1, perPage: 10 },
		{ field: "id", order: "DESC" }
	);

	const onSuccess = () => {
		notify(translate("background-modules.create.success"), "info");
		redirect("/background-modules");
		refresh();
	};

	const onFailure = (error) => {
		notify(error.message, "warning");
	};

	useEffect(() => {
		setLanguageData(getChoices(languageDataObj));
	}, [languageDataObj]);

	return (
		<Create
			transform={transform}
			onSuccess={onSuccess}
			onFailure={onFailure}
			{...props}
			title="background-modules.create.title"
		>
			<SimpleForm
				toolbar={<CustomToolbar />}
				validate={validateBackgroundModuleData}
			>
				<TextInput source="name" />
				<RadioButtonGroupInput
					source="languageId"
					choices={languageData}
					optionText={({ name }) => `misc.names.languages.${name}`}
					optionValue="id"
				/>
				<FileInput
					key={translate(`background-modules.create.audioFile`)}
					{...props}
					source="audio"
					label={translate(`background-modules.create.audioFile`)}
				>
					<FileField source="src" title="Background Module" />
				</FileInput>
			</SimpleForm>
		</Create>
	);
};
